import { render } from "./CustomResourceTableRow.vue?vue&type=template&id=3348426d"
import script from "./CustomResourceTableRow.vue?vue&type=script&lang=js"
export * from "./CustomResourceTableRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomResourceTableRow.vue"]])

export default __exports__